export default {
  primary: "#00995D", // Purple
  secondary: "#b1d34b", // Orange
  accent: "#ECECEC", // Gray
  dark: "#424242",
  error: "#ff5252",
  warning: "#F47920"
};
